import { useAppSelector } from 'shared';

// eslint-disable-next-line import/prefer-default-export
export const useDeliveryPageState = () => useAppSelector((store) => store.deliveryPage);
